<template>
  <DialogTemplate
    style="max-width: 72rem; padding: 0"
    contentClasss="pa-0 ma-0"
  >
    <div class="text-large pl-2 weight_700">Roadmap</div>

    <div class="roadmap-list mt-2 pa-1">
      <div class="roadmap-sections">
        <ul
          v-for="(ul, idx) in sections.features"
          :key="idx"
          class="ma-4"
        >
          <h4
            class="road"
            :style="ul.style"
          >
            {{ ul.name }}

            <span
              v-if="ul.date"
              class="text-small clr-grey weight_400 pl-2"
              >{{ ul.date }}</span
            >
          </h4>
          <li
            v-for="(li, i) in ul.items"
            :key="idx + i"
            class="pt-1"
            v-html="li"
          ></li>
        </ul>
      </div>
    </div>

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'

export default {
  name: 'RoadmapDialog',
  components: {
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  data() {
    return {
      tab: 'features',
      sections: {
        features: [
          {
            name: 'Planning',
            items: [
              'River reports',
              'Custom solving PLO',
              'Simplifying the learning curve',
              'IOS/Android mobile app',
            ],
          },
          {
            name: 'In Progress',
            items: [
              'GTO Reports', //
              'Leaderboards',
              'Multiway solver',
              'Quizzes',
            ],
          },
          {
            name: 'SOON',
            style: 'color:var(--clr-yellow)',
            items: [
              'Hand analyzer updates',
              'Node locking of presolved solutions',
              'Study and Trainer Quickplay',
              'Bundles',
            ],
          },
        ],
      },
    }
  },

  methods: {
    close() {
      this.$store.dispatch('router_reset_dialogs')
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .roadmap-sections {
    flex-direction: column;
    max-height: 60vh;
  }
  .login-dialog {
    &_container {
      padding: 1rem !important;
    }
  }
}

.login-dialog {
  top: 0;
  left: 0;
  position: fixed;
  display: flex;
  align-items: center;

  justify-content: center;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.9);
  height: var(--vh-100);

  width: 100vw;
  &_container {
    box-shadow: 0 0 0px 1px black;
    background: var(--clr-black-0);
    padding: 3rem;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    position: relative;
  }
}
.roadmap-sections {
  display: flex;
  overflow: auto;
  .road {
    position: relative;
    padding-bottom: 0.5rem;
    left: -20px;
  }
}
</style>
